/* src/app/modules/portal/components/advanced-search-pane/advanced-search-pane.component.scss */
:host {
  z-index: 1;
}
sh-pane {
  height: 100%;
}
form {
  height: 100%;
}
.tag-item {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-flex;
  padding-right: 4px;
  margin-top: 4px;
}
.info-advances-search-message {
  width: 335px;
  padding-left: 12px;
  word-break: break-word;
  color: #6c757d;
}
.info-advances-search-message strong {
  font-weight: bold;
  color: #6c757d;
}
.spinner-padding {
  padding: 12px 0;
  display: flex;
  justify-content: center;
}
.dropdown-with-tags {
  margin-bottom: 0px;
}
/*# sourceMappingURL=advanced-search-pane.component.css.map */
